/**
 * Throws when `value` is falsy, and narrows its type for the code after it.
 */
export function assert(value: unknown, message?: string): asserts value {
  if (!value) throw new Error(message ?? 'Assertion failed');
}
